declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SavePatientInfoRequest, PatientInfoByFormattedCodeController, UpdatePatientInfoRequest, SaveActorRegistationType, GenericProcPostRequest, S_Methods, SaveJoinSpouse } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from '../../../../ivf/ivfworkbench/searchprovider.modal';
import { NgbSearchPatientModal } from '../../../../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbCameraUploadModal } from './cameraupload.modal';
import { NgbPartnerSearchpatientModal } from '../../../../follow up/counsellingregistry/modal/partnersearchpatient.modal';
import { NgbCustSearchProviderModal } from '../../../../ivf/ivfworkbench/custsearchprovider.modal';

@Component({
  selector: 'ngbcusteditprofile',
  templateUrl: './custeditprofile.modal.html',
  styleUrls: ['./custeditprofile.modal.scss']
})

export class NgbCustEditProfileModal implements OnInit, OnChanges {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;

  // @Input() CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  @Input() CurrentSavePatientInfoRequest: UpdatePatientInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  DOB: NgbDateStruct;
  WeddingDate: NgbDateStruct;
  RegistrationVal: NgbDateStruct;
  VaildFrom: NgbDateStruct;
    ValidTo: NgbDateStruct;
    
  public SelectedSource: string;
  public ProviderName: string;
  public ProviderCode: number;
  public ProviderNumber: string;
  public PrimaryDoctor: string;
  public PrimaryCode: number;
  public PrimaryNumber: number;
  public ProviderName1: string;
  public ProviderCode1: number;
  public ProviderNumber1: string;
  public PatientName: string;
  public PatientActorCode: number;
  public PatientNumber: string;
    public StaffName: string;
    public Institute: string;
  public StaffCode: number;
  public StaffNumber: string;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public PrimaryDoctorO: boolean = true;
  public PrimaryDoctorn: boolean = false;
  public LoginCountry: string;

  public PartnerName: string;
  public PartnerFormattedCode: string;
  public PartnerActorCode: number;
  public SpouseNameO: boolean = true;
  public SpouseNameN: boolean = false;
    Todate = new Date();
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnChanges(changes: SimpleChanges) {
    //alert('yeah - 0');
    //for (const propName in changes) {
    //  if (changes.hasOwnProperty(propName)) {
    //    alert(propName);
    //    switch (propName) {
    //      case 'CurrentSavePatientInfoRequest.County': {
    //        alert('yeah');
    //       // this.doSomething(change.currentValue)
    //      }
    //    }
    //  }
    //}
    
  }
  ngOnInit() {

    this.ShowService = false;
    //alert(this.CurrentSavePatientInfoRequest.PrimaryDoctor);
      this.minDate = { year: 1900, month: 1, day: 1 };
      this.maxDate = { year: this.Todate.getFullYear(), month: 1, day: 1 };
    this.LoadRegistries();


    //alert(this.CurrentSavePatientInfoRequest.DateOfBirth);
    if (this.CurrentSavePatientInfoRequest.DateOfBirth != null) {
      var SValidFrom = new Date(this.CurrentSavePatientInfoRequest.DateOfBirth);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.DOB = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentSavePatientInfoRequest.WeddingAnniversary != null) {
      var SValidFrom = new Date(this.CurrentSavePatientInfoRequest.WeddingAnniversary);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.WeddingDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentSavePatientInfoRequest.RegistrationValidity != null) {
      var SValidFrom = new Date(this.CurrentSavePatientInfoRequest.RegistrationValidity);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.RegistrationVal = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }

    this.LoginCountry = AppData.Instance().cas.LoginCountry;

  }

  IsLocalCountry() :boolean {
    var cns = this.LoginCountry.trim().split("|");
    //alert(cns.length);
    //alert(cns.indexOf(this.CurrentSavePatientInfoRequest.County));
    for(var c in cns)
    {
      if (c.trim() == this.CurrentSavePatientInfoRequest.County.trim())
        return true;

      if (c.indexOf(this.CurrentSavePatientInfoRequest.County.trim()) > -1)
        return true;
    }
    return false;
  }



  //BranchMapData: ServiceBranchMapByServiceCodeController[];
  //BranchMapRequest: ServiceBranchMapByServiceCodeRequest;
  //this.pdata = this.CurrentCustomCodeValuesController;
  LoadRegistries() {
    this.StartRefreshing();




    //this.GetBranchMap();



  }
  //General() {

  //}
  General() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 7;
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));

    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Education() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 14;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }

  Referral() {
    this.StartRefreshing();
    if (this.SelectedSource == "DOC") {
      this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber;
    }
    else if (this.SelectedSource == "DOCEX") {
      //  this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode1;
      //this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName1;
      //  this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber1;
        if (this.CurrentSavePatientInfoRequest.RefCode == null) {
            this.CurrentSavePatientInfoRequest.RefCode = -1;
        }

    }
    else if (this.SelectedSource == "RGPT") {
      this.CurrentSavePatientInfoRequest.RefCode = this.PatientActorCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.PatientName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.PatientNumber;
    }
    else if (this.SelectedSource == "STAFF") {
      this.CurrentSavePatientInfoRequest.RefCode = this.StaffCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.StaffName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.StaffNumber;
    }
    else if (this.SelectedSource !== "DOC" || "DOCEX" || "RGPT" || "STAFF") {
      this.CurrentSavePatientInfoRequest.RefCode = 0;

    }

    this.CurrentSavePatientInfoRequest.ConditionalOperator = 35;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Adress() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 42;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Contact() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 49;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  onChange2(event: any) {
    this.SelectedSource = event;
    // alert(this.SelectedSource)

  }
  SelectInternalDoctor() {
    const modalRef = this.modalService.open(NgbCustSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProviderName = receivedEntry.make;
      this.ProviderCode = receivedEntry.value;
      this.ProviderNumber = receivedEntry.number;
      //alert(this.ProviderName);
    })
  }
  SelectExternalDoctor() {
    const modalRef = this.modalService.open(NgbCustSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = false;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProviderName1 = receivedEntry.make;
      this.ProviderCode1 = receivedEntry.value;
        this.ProviderNumber1 = receivedEntry.number;      //alert(this.ProviderName);
        this.Institute = receivedEntry.Institute;
          this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode1;
      this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName1;
        this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber1;
        this.CurrentSavePatientInfoRequest.RefInstitute = this.Institute;
    })
  }
  SelectStaff() {
    const modalRef = this.modalService.open(NgbCustSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.StaffName = receivedEntry.make;
      this.StaffCode = receivedEntry.value;
      this.StaffNumber = receivedEntry.number;
      //alert(this.ProviderName);
    })
  }
  SelectPatient() {
    const modalRef = this.modalService.open(NgbCustSearchProviderModal,
      {
        centered: true,
        size: 'lg'
      })
    modalRef.componentInstance.PATIENT_OBJ = true;
    modalRef.componentInstance.PATIENT_FORMATTED_CODE = false;
    modalRef.result.then((val: PatientInfoByFormattedCodeController) => {
      // alert(val.DisplayName);

      this.PatientActorCode = val.ActorCode;

      this.PatientName = val.DisplayName;
      this.PatientNumber = val.Telephone1;

    });
  }

  SelectPrimaryDoctor() {
    this.PrimaryDoctorO = false;
    this.PrimaryDoctorn = true;
    const modalRef = this.modalService.open(NgbCustSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.PrimaryDoctor = receivedEntry.make;
      this.PrimaryCode = receivedEntry.value;
      this.PrimaryNumber = receivedEntry.number;
      this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.PrimaryDoctor;
    })
  }
  public DepartmentCode: number;
  CountryName: string;
  Country(event: any) {

    if (event != null) {
      this.CountryName = event;
      //alert(this.CountryName);
    }

  }
}
